// extracted by mini-css-extract-plugin
export default {"menuList":"SideMenu_menuList__FF6eq","menuListItem":"SideMenu_menuListItem__sfVaC","navLink":"SideMenu_navLink__70nrw","active":"SideMenu_active__aFKRz"};